import React from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { colors } from '../../shared/theme/colors'
import { spacing } from '../../shared/theme/spacing'
import { typography } from '../../shared/theme/typography'
import { ticketColors } from '../../shared/theme/ticketColors';
import { modalExperience } from '../../shared/modals/modalExperience.styles';
import type { CustomerAccountRow } from '../domain/customerTypes';

type Props = {
  customer: CustomerAccountRow;
  notesExpanded: boolean;
  onToggleNotes: () => void;
};

export function CustomerDetailNotesSection({ customer, notesExpanded, onToggleNotes }: Props) {
  if (!customer.notes) return null;

  return (
    <View style={modalExperience.detailFlatSection}>
      <TouchableOpacity
        style={styles.notesHeader}
        onPress={onToggleNotes}
        accessibilityRole="button"
        accessibilityLabel={notesExpanded ? 'Ocultar nota rápida' : 'Mostrar nota rápida'}
      >
        <Text style={modalExperience.detailBlockTitle}>Nota rápida</Text>
        <Ionicons
          name={notesExpanded ? 'chevron-up' : 'chevron-down'}
          size={14}
          color={ticketColors.ink3}
        />
      </TouchableOpacity>
      {notesExpanded ? (
        <Text style={styles.notesText}>{customer.notes}</Text>
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  notesHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  notesText: {
    ...typography.body,
    color: ticketColors.ink2,
    marginTop: spacing.xs,
    lineHeight: 20,
  },
});
